module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"testMode":"E-Mail-Testmodus aktiv:"},"en":{"testMode":"Email test mode active:"}}')
  delete Component.options._Ctor
}
